<template>
    <div class="ts-finder__resultlist-item ts-finder__resultlist-item--station" :class="{ 'ts-finder__resultlist-item--selected' : isSelected || preselected, 'ts-finder__resultlist-item--station-search' : isSearchMode }" @click="stationClicked">

        <!--logo-->
        <img :src="logoUrl" class="ts-finder__resultlist-logo" />

        <!--details-->
        <div class="ts-finder__resultlist-details">
            <div class="ts-finder__resultlist-name">{{this.station.name}}</div>
            <div class="ts-finder__resultlist-address" v-if="this.station.address" v-html="this.station.address"></div>
            <ul class="ts-finder__resultlist-services-list" v-if="!isSearchMode">
                <li class="ts-finder__icon ts-finder__icons-tankstelle" v-if="this.station.tankstelle" :title="strings['TsFinder.Filter.Tankstelle']"></li>
                <li class="ts-finder__icon ts-finder__icons-fastcharging" v-if="this.station.fastcharging" :title="strings['TsFinder.Filter.FastCharging']"></li>
                <li class="ts-finder__icon ts-finder__icons-wasserstoff" v-if="this.station.wasserstoff" :title="strings['TsFinder.Filter.Wasserstoff']"></li>
                <li class="ts-finder__icon ts-finder__icons-shop" v-if="this.station.shop" :title="strings['TsFinder.Filter.Shop']"></li>
                <li class="ts-finder__icon ts-finder__icons-migrolino" v-if="this.station.migrolino" :title="strings['TsFinder.Filter.ShopMigrolino']"></li>
                <li class="ts-finder__icon ts-finder__icons-mio" v-if="this.station.mio" :title="strings['TsFinder.Filter.ShopMio']"></li>
                <li class="ts-finder__icon ts-finder__icons-carwash" v-if="this.station.carwash" :title="strings['TsFinder.Filter.CarWash']"></li>
                <li class="ts-finder__icon ts-finder__icons-autoservice" v-if="this.station.autoservice" :title="strings['TsFinder.Filter.AutoService']"></li>                
                <li class="ts-finder__icon ts-finder__icons-migrolcard" :title="strings['TsFinder.Filter.IsMigrolStandort']"></li>
            </ul>
        </div>

        <!--directions-->
        <div class="ts-finder__resultlist-directions" v-if="!isSearchMode">
            <a class="ts-finder__resultlist-directions-link" :href="directionsUrl" target="_blank" v-if="directionsUrl" :title="strings['TsFinder.Filter.Routeplanner']"><i class="fas fa-directions"></i></a><br />
            {{distance | formatDistance}}
        </div>

    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex'
    import * as Utils from '../../../utils/utils'

    export default {
        props: ['station', 'isSearchMode', 'preselected'],
        computed: {
            ...mapState([
                'userLocation',
                'selectedStation',
                'strings'
            ]),
            directionsIcon() {
                return window.TS_CONFIG.directions;
            },
            logoUrl() {
                return this.station.brandurl;
            },
            directionsUrl() {
                return Utils.createDirectionsUrl(this.station, this.userLocation);
            },
            distance() {
                if (this.station.latitude && this.station.longitude && this.userLocation != null) {
                    return Utils.calculateDistance(this.userLocation.latitude, this.userLocation.longitude, this.station.latitude, this.station.longitude);
                } else {
                    return null;
                }
            },
            isSelected() {
                return this.selectedStation != null && (this.selectedStation.id == this.station.id);
            }
        },
        methods: {
            ...mapActions([
                'selectStation'
            ]),
            stationClicked() {
                this.selectStation(this.station);
                this.$emit('station-selected')
            }
        }
    };
</script>